import { useTranslation } from "react-i18next";
import { HowToBuyList } from "./HowToBuyList";
import { howToBuyTrns } from "../trns";

export const HowToBuy = () => {
  const { t } = useTranslation();

  return (
    <section className="container flex flex-col items-center justify-center gap-5">
      <div className="flex flex-col gap-2 items-center">
        <h3>{t(howToBuyTrns.title)}</h3>

        <p className="text-lg text-blue-dark text-justify font-semibold md:w-3/5">
          {t(howToBuyTrns.description)}
        </p>
      </div>

      <HowToBuyList />
    </section>
  );
};
